import React from 'react';
export function Footer() {
  return <footer className="bg-brand-card/50 border-t border-brand-border py-8 px-4 text-center" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <div className="font-body text-xs text-brand-textMuted tracking-wide" data-id="element-136">
          © El Manual del Instructor de Bachata 2025
        </div>
      </div>
    </footer>;
}